import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

/**
 * Props for rendering a user-created custom widget
 */
export type Props = {
  /**
   * The name of the custom widget to render
   */
  customWidgetName: string;
  
  /**
   * The specific version to use (optional - defaults to published version)
   */
  customWidgetVersion?: string;
  
  /**
   * User-defined props that will be passed to the widget
   * These are defined by the widget's propsSchema
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  widgetProps?: Record<string, any>;
};

const propsSchema: PropsSchemaList = [
  {
    key: 'customWidgetName',
    label: 'Custom Widget',
    type: types.TEXT,
  },
  {
    key: 'customWidgetVersion',
    label: 'Version',
    type: types.TEXT,
  },
  {
    key: 'widgetProps',
    label: 'Widget Properties',
    type: types.OBJECT,
  }
];

const defaultProps: Props = {
  customWidgetName: '',
  customWidgetVersion: '',
  widgetProps: {}
};

export default {
  title: 'Custom Widget',
  id: 'CustomWidget',
  propsSchema,
  defaultProps
};

